import TimeOptions from './TimeOptions';
import { format, toZonedTime } from 'date-fns-tz'

class Time {

    dateValue: Date;

    constructor(options: TimeOptions) {
        var that = this;

        var d = new Date();

        if (options) {
            d.setHours(options.hour);
            d.setMinutes(options.minute);
            d.setSeconds(options.second);
        }

        this.dateValue = d;

        this.toString = function () {
            
            return format(toZonedTime(this.dateValue, Time.getTimezone()), "", { timeZone: Time.getTimezone() });
        };
    }

    static getTimezone() {
        return InovxLoader.getLocaleData().tz == "" ? Intl.DateTimeFormat().resolvedOptions().timeZone : InovxLoader.getLocaleData().tz;
    }
}

export default Time;